import {
  StakeProgram,
} from '@solana/web3.js';
import { getConnection } from '@/helpers/solana/getConnection';


let minRent: null | number = null;
export async function getMinRent() {
  if (minRent !== null) return minRent;
  minRent = await getConnection().getMinimumBalanceForRentExemption(
    StakeProgram.space,
  );
  return minRent;
}
